<template>
  <div>
    <div class="container">
      <jumbotron />
      <user-articles />
      <new-articles />
      <articles-on-sales />
    </div>

    <highlihgted-categories />

    <div class="container">
      <home-banner />
    </div>

    <mobile-app />
    <top-brands />

    <div
      v-if="isSajamDialogVisible"
      class="home-sajam-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="Sajam"
      @click.self="closeSajamDialog"
    >
      <div class="home-sajam-dialog__image-wrap">
        <button
          type="button"
          class="home-sajam-dialog__close"
          aria-label="Close dialog"
          @click="closeSajamDialog"
        >
          <span class="home-sajam-dialog__close-icon">&times;</span>
        </button>

        <img
          class="home-sajam-dialog__image"
          src="/assets/images/banners/sajam.png"
          alt="Sajam"
        >
      </div>
    </div>
  </div>
</template>

<script>
import UserArticles from './UserArticles.vue';
import NewArticles from './NewArticles.vue';
import Jumbotron from './Jumbotron.vue';
import HighlihgtedCategories from './HighlihgtedCategories.vue';
import ArticlesOnSales from './ArticlesOnSales.vue';
import HomeBanner from './HomeBanner.vue';
import TopBrands from './TopBrands.vue';
import MobileApp from './MobileApp.vue';

export default {
  name: 'Dashboard',
  components: {
    UserArticles,
    NewArticles,
    Jumbotron,
    HighlihgtedCategories,
    ArticlesOnSales,
    HomeBanner,
    TopBrands,
    MobileApp,
  },
  data() {
    return {
      isSajamDialogVisible: false,
      previousBodyOverflow: '',
    };
  },
  // mounted() {
  //   this.$store.dispatch('getAttributes', { retrieveAll: true });
  // },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('keydown', this.handleSajamDialogKeydown);
    this.openSajamDialog();
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleSajamDialogKeydown);
    this.unlockBodyScroll();
  },
  methods: {
    openSajamDialog() {
      if (this.isSajamDialogVisible) return;

      this.previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.isSajamDialogVisible = true;
    },
    closeSajamDialog() {
      this.isSajamDialogVisible = false;
      this.unlockBodyScroll();
    },
    unlockBodyScroll() {
      document.body.style.overflow = this.previousBodyOverflow;
    },
    handleSajamDialogKeydown(event) {
      if (event.key === 'Escape' && this.isSajamDialogVisible) {
        this.closeSajamDialog();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-sajam-dialog {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.72);
}

.home-sajam-dialog__image-wrap {
  position: relative;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  width: 400px;
  height: 500px;
  max-width: calc(100vw - 40px);
  max-height: calc(100vh - 40px);
  line-height: 0;
}

.home-sajam-dialog__close {
  position: absolute;
  top: 6px;
  right: 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.65);
}

.home-sajam-dialog__close-icon {
  display: block;
  font-size: 42px;
  font-weight: 400;
  line-height: 1;
}

.home-sajam-dialog__image {
  display: block;
  width: 400px;
  height: 500px;
  max-width: 100%;
  max-height: 100%;
}

@media (max-width: 767px) {
  .home-sajam-dialog {
    padding: 12px;
  }

  .home-sajam-dialog__close {
    top: 8px;
    right: 10px;
    width: 40px;
    height: 40px;
  }

  .home-sajam-dialog__close-icon {
    font-size: 34px;
  }

  .home-sajam-dialog__image {
    width: 100%;
    height: 100%;
  }
}
</style>
